import React from "react";

import { Utils } from "../../../common/utils";
import { InputBase } from "components/Atoms/formInputs/InputBase";
import { routes } from "utilities/routing/generatedRoutes";
import { HtmlEditor } from "components/ValidatedFields/HtmlEditor";
import OptionalTextAreaInput from "components/ValidatedFields/OptionalTextAreaInput";

interface Props {
  initialEmailProfile: server.dto.UserEmailProfile
}

interface IState {
  emailProfile: server.dto.UserEmailProfile
  emailWarning?: string
  senderWarning?: string
  signatureWarning?: string
}

// TODO: Rewrite this to use EditTemplate
export default class EmailSettingsPanel extends React.Component<Props, IState> {
  state: IState = {
    emailProfile: this.props.initialEmailProfile,
    emailWarning: "",
    senderWarning: "",
    signatureWarning: ""
  };

  componentDidMount() {
    window.CoreApi.UserEmailProfile.GetUserEmailProfile()
      .then(profile => { this.setState({ emailProfile: profile.data.data }); });
  }

  onEmailChanged = (value: string) => {
    const error = this.validateEmail(value);

    this.setState({
      emailProfile: {
        ...this.state.emailProfile,
        email: value
      },
      emailWarning: error
    });
  };

  validateEmail = (email: string): string => {
    if (email.trim() === "") {
      return RESX.Advancing.EmailRequired;
    }

    const parsed = Utils.getValidEmails(email);

    if (parsed.length === 0) {
      return RESX.GeneralLabels.EmailIsInvalid;
    }

    if (parsed.length > 1) {
      return RESX.Email.OnlyOneEmail;
    }

    return "";
  };

  validateSender = (sender: string): string => {
    if (sender.trim() === "") {
      return RESX.GeneralWarnings.PleaseFillInThisField;
    }

    return "";
  };

  onSenderChanged = (value: string) => {
    const errorMessage = this.validateSender(value);

    this.setState({
      emailProfile: {
        ...this.state.emailProfile,
        displayName: value
      },
      senderWarning: errorMessage
    });
  };

  onSignatureChanged = (signature: string) => {
    const error = this.validateSignature(signature);

    this.setState({
      signatureWarning: error,
      emailProfile: {
        ...this.state.emailProfile,
        signature
      }
    });
  };

  validateSignature = (signature): string => {
    if (signature.trim() === "") {
      return RESX.GeneralWarnings.PleaseFillInThisField;
    }

    return "";
  };

  onDefaultBccBlur = (v: string) => {
    const validatedBcc = Utils.processManualRecipientsString(v);

    this.setState({
      emailProfile: {
        ...this.state.emailProfile,
        defaultBcc: validatedBcc
      }
    });
  };

  onDefaultBccChange = (value: string) => {
    this.setState({
      emailProfile: {
        ...this.state.emailProfile,
        defaultBcc: value
      }
    });
  };

  saveEmailSetting = () => {
    let canSave = true;

    if (this.validateEmail(this.state.emailProfile.email)) {
      canSave = false;
    }

    if (this.validateSender(this.state.emailProfile.displayName)) {
      canSave = false;
    }

    if (this.validateSignature(this.state.emailProfile.signature)) {
      canSave = false;
    }

    if (canSave) {
      this.performSave(this.state.emailProfile);
    }
  };

  performSave = async (emailProfile: server.dto.UserEmailProfile) => {
    await window.CoreApi.UserEmailProfile.UpdateEmailPreferences(emailProfile);
    window.location.href = routes.personal_SettingMenu().absolute;
  }

  public render(): JSX.Element {
    return <>
      <table className="s1_table clean rowspace">
        <tbody>
          <tr>
            <td>{RESX.GeneralLabels.Email}</td>
            <td>
              <InputBase
                maxLength={100}
                error={this.state.emailWarning}
                onChange={this.onEmailChanged}
                value={this.state.emailProfile.email}
              />
            </td>
          </tr>
          {site.currentEnvironment.type !== "external" && <>
            <tr>
              <td>{RESX.PersonalSettings.Sender}</td>
              <td>
                <InputBase
                  maxLength={80}
                  error={this.state.senderWarning}
                  onChange={this.onSenderChanged}
                  value={this.state.emailProfile.displayName}
                />
              </td>
            </tr>
            <tr>
              <td>{RESX.SoUser.Signature}</td>
              <td>
                <HtmlEditor
                  toolbar="Normal"
                  maxContentLength={serverReference.constants.emailMessage.maxBodyLength}
                  onChange={this.onSignatureChanged}
                  content={this.state.emailProfile.signature}
                  error={Boolean(this.state.signatureWarning)}
                />
                <div className="s1_warning">
                  {this.state.signatureWarning}
                </div>
              </td>
            </tr>
            <tr>
              <td>{RESX.PersonalSettings.DefaultRecipientsInBccField}</td>
              <td>
                <OptionalTextAreaInput
                  maxLength={1000}
                  value={this.state.emailProfile.defaultBcc}
                  onChange={this.onDefaultBccChange}
                  onBlur={this.onDefaultBccBlur}
                />
              </td>
            </tr>
          </>}
        </tbody>
      </table>
      <div>
        <div className="flex justify-end margin-top-bigger">
          <button
            className="button-new primary"
            type="button"
            id="btnSave"
            onClick={this.saveEmailSetting}>
            {RESX.Buttons.btnSave}
          </button>
        </div>
      </div>
    </>;
  }
}
